import { Injectable, signal, inject, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenStorage } from './token.storage';
import { AuthResponse, UsuarioResponse } from '../models/auth.models';
import { environment } from '../../environments/environment';
import { ToastService } from '../services/toast.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private tokenStorage = inject(TokenStorage);
  private toastService = inject(ToastService);

  // State signals reativos
  token = signal<string | null>(this.tokenStorage.getToken());
  currentUser = signal<UsuarioResponse | null>(this.tokenStorage.getUser());
  isAuthenticated = computed(() => !!this.token());
  isAdmin = computed(() => this.currentUser()?.role?.toLowerCase() === 'admin');

  /**
   * Autentica no backend Cerimonial utilizando o Google ID Token
   */
  loginWithGoogle(idToken: string): Observable<AuthResponse> {
    return this.http.post<any>(`${environment.apiUrl}/auth/google`, { idToken }).pipe(
      map(res => {
        const authData: AuthResponse = res?.data ?? res;
        if (!authData?.token || !authData?.usuario) {
          throw new Error('Dados de autenticação inválidos retornados pelo servidor.');
        }
        this.setAuthSession(authData);
        return authData;
      })
    );
  }

  setAuthSession(auth: AuthResponse): void {
    this.tokenStorage.saveToken(auth.token);
    this.tokenStorage.saveUser(auth.usuario);
    this.token.set(auth.token);
    this.currentUser.set(auth.usuario);
  }

  logout(): void {
    this.tokenStorage.clear();
    this.token.set(null);
    this.currentUser.set(null);
    this.toastService.clear();
    this.router.navigate(['/login']);
  }
}
